import { render } from "./RealizarAssinaturaDeclaracao.vue?vue&type=template&id=07062a3b&scoped=true"
import script from "./RealizarAssinaturaDeclaracao.vue?vue&type=script&lang=js"
export * from "./RealizarAssinaturaDeclaracao.vue?vue&type=script&lang=js"

import "./RealizarAssinaturaDeclaracao.vue?vue&type=style&index=0&id=07062a3b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07062a3b"]])

export default __exports__